<template>
    <span id="message" :style="style">{{message}}</span>
</template>
<script>

import StopServiceActionForm from "../app-provider/components/StopServiceActionForm";
export default {
    name: "ToastNotification",
    components: {StopServiceActionForm},
    data(){
        return {
            colors: ['red', 'green']
        }
    },
    props:{
        message: String,
        backgroundColor: String
    },
    computed:{
        style(){
            if(this.colors.includes(this.backgroundColor)) {
                return `background-color: ${this.backgroundColor}`
            }else{
                return `background-color:  'green'`
            }
        }
    },
    methods:{
        removeMessage(){
            const message = document.getElementById('message');
            message.style.opacity = "0"
            setTimeout(()=>{
                message.style.display = "none";
            },5000)
        },
        showMessage(){
            const message = document.getElementById('message');
            message.style.display = "block"
            setTimeout(()=>{
                message.style.opacity = "1";
                setTimeout(()=>{
                   this.removeMessage()
                },5000)
            },.500)
        }
    },
    watch:{
        message(newMessage, oldMessage){
            if(newMessage){
                this.showMessage()
            }else{
                this.removeMessage()
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    span{
        position: fixed;
        top: 4rem;
        right: 1rem;
        color: white;
        padding: 1rem;
        border-radius: 5px;
        transition: all .5s;
        max-width: 375px;
        opacity: 0;
        display: none;
        z-index: 9999;
    }
</style>
